// extracted by mini-css-extract-plugin
module.exports = {"pressVideo":"PressVideo_pressVideo__2OT_Q"};